import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import { GdprConfiguration, GdprSaveBody } from '@recruitee/http/types';
import { I18nService } from '@recruitee/i18n';
import { createEffectFactory } from '@recruitee/ngrx';
import { NotificationsController } from '@recruitee/user-interface';

import { GdprConfigurationHttpClient } from './gdpr-configuration-http-client';
import { GdprConfigurationActions } from './gdpr-configuration.store';

@Injectable({ providedIn: 'root' })
export class GdprConfigurationEffects {
  public effect = createEffectFactory(GdprConfigurationActions, this.actions$);

  public fetchGdprConfiguration$ = this.effect(GdprConfigurationActions.fetch, () =>
    this.gdprConfigurationHttpClient.fetch().pipe(filterBoolean),
  );

  public saveGdprConfiguration$ = this.effect(
    GdprConfigurationActions.update,
    ({ payload }: { payload: GdprSaveBody }) => this.gdprConfigurationHttpClient.save(payload),
  );

  public saveGdprNotification$ = this.effect(
    GdprConfigurationActions.updateSuccess,
    () => this.notificationController.success(this.i18n.translate('app.gdpr.form_saved')),
    { dispatch: false },
  );

  public toggleGDPRFeature$ = this.effect(
    GdprConfigurationActions.toggleGDPRFeature,
    ({ payload }) =>
      this.gdprConfigurationHttpClient.save(payload).pipe(
        switchMap((payload: GdprConfiguration) => [
          GdprConfigurationActions.toggleGDPRFeatureSuccess({
            payload,
          }),
        ]),
      ),
  );

  public toggleGDPRFeatureSuccess$ = this.effect(
    GdprConfigurationActions.toggleGDPRFeatureSuccess,
    data => {
      this.notificationController.success(
        this.i18n.translate(
          data.payload.enabled ? 'app.gdpr.gdpr_enabled' : 'app.gdpr.gdpr_disabled',
        ),
      );
    },
    { dispatch: false },
  );

  constructor(
    private gdprConfigurationHttpClient: GdprConfigurationHttpClient,
    private notificationController: NotificationsController,
    private i18n: I18nService,
    private actions$: Actions,
  ) {}
}
